import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { SessionUser } from 'src/app/shared/models/sessionUser';
import { environment } from 'src/environments/environment';
import { SpinnerComponent } from '../components/spinner/spinner.component';
import { LocalStorageService } from './local-storage.service';
import { Constanst } from '../constants/constans.component';

@Injectable({
  providedIn: 'root'
})
export class ApiCallService {
  private headers = new HttpHeaders();
  private json: any;
  private spinnerLoading: SpinnerComponent

  public modelSesion: SessionUser = {
    tokenName: environment.tokenName,
    tokenValue: '',
    platformValue: environment.platformValue,
    platformName: environment.platformName,
    contentType: environment.contentType,
    contentTypeValue: environment.contentTypeValue,
    apiKeyName: environment.apiKeyName,
    apiKeyValue: environment.apiKeyValue,
    idUser: 0,
    idProfile: 0
  }

  constructor(
    private httpClient: HttpClient,
    private ngxSpinner: NgxSpinnerService,
    private localStorageService: LocalStorageService
  ) {
    this.spinnerLoading = new SpinnerComponent(ngxSpinner);
  }

  /**
   * Métooo de llamada a los servicios del API.
   * @param data solo para métodos POST.
   * @param route ruta del método.
   * @param method tipo de método POST/GET.
   * @param status si el usuario está logueado true/false.
   * @param messengLoading mensaje que aparecerá en la cortina de carga.
   * @param block activar cortina de carga true/false.
   */
   call$(data: any, route: any, method: any, status: boolean, messengLoading: string, block?: boolean): Observable<any> {
    // Se apertura spiner de carga con mensaje
    if (block) {
      this.spinnerLoading.showSpinner();
    }
    switch (method.toUpperCase()) {
      case 'GET':
        if (status === true) {
          this.headers = new HttpHeaders().set(this.modelSesion.tokenName, this.localStorageService.getItem(Constanst.STORAGE_DATA_CODE) || '')
          .set(this.modelSesion.contentType, this.modelSesion.contentTypeValue)
          .set(this.modelSesion.platformName, this.modelSesion.platformValue);
          return this.httpClient.get(environment.apiUrl + route, {headers: this.headers});
        } else {
          this.headers = new HttpHeaders().set(this.modelSesion.platformName, this.modelSesion.platformValue)
          .set(this.modelSesion.contentType, this.modelSesion.contentTypeValue);
          return this.httpClient.get(environment.apiUrl + route, {headers: this.headers});
        }
      case 'POST':
        if (data != null) {
          if (status === true) {
            this.headers = new HttpHeaders().set(this.modelSesion.platformName, this.modelSesion.platformValue).
              set(this.modelSesion.tokenName, this.localStorageService.getItem(Constanst.STORAGE_DATA_CODE) || '').
            set(this.modelSesion.contentType, this.modelSesion.contentTypeValue);
            this.json = JSON.stringify(data);
            return this.httpClient.post(environment.apiUrl + route, this.json, {headers: this.headers});
          } else {
            this.headers = new HttpHeaders().set(this.modelSesion.platformName, this.modelSesion.platformValue)
            .set(this.modelSesion.contentType, this.modelSesion.contentTypeValue)
            .set(this.modelSesion.apiKeyName, this.modelSesion.apiKeyValue);
            this.json = JSON.stringify(data);
            return this.httpClient.post(environment.apiUrl + route, this.json, {headers: this.headers});

          }
        } else {
          if (status === true){
            this.headers = new HttpHeaders().set(this.modelSesion.tokenName, this.localStorageService.getItem(Constanst.STORAGE_DATA_CODE) || '')
            .set(this.modelSesion.contentType, this.modelSesion.contentTypeValue)
            .set(this.modelSesion.platformName, this.modelSesion.platformValue);
            this.json = {};
            return this.httpClient.post(environment.apiUrl + route, this.json , {headers: this.headers});
          } else {
            this.headers = new HttpHeaders().set( this.modelSesion.tokenName, this.modelSesion.tokenValue )
            .set(this.modelSesion.contentType, this.modelSesion.contentTypeValue)
            .set(this.modelSesion.platformName, this.modelSesion.platformValue);
            this.json = {};
            return this.httpClient.post(environment.apiUrl + route, this.json , {headers: this.headers});
          }
        }
      default: {
        return this.httpClient.post(environment.apiUrl + route, this.json , {headers: this.headers});
      }
    }
  }

  /**
 * Métooo de llamada a los servicios del API.
 * @param data solo para métodos POST.
 * @param route ruta del método.
 * @param method tipo de método POST/GET.
 * @param status si el usuario está logueado true/false.
 * @param messengLoading mensaje que aparecerá en la cortina de carga.
 * @param block activar cortina de carga true/false.
 */
  callFile$(data: any, route: any, method: any, status: boolean, messengLoading: string, block?: boolean): Observable<any> {
    // Se apertura spiner de carga con mensaje
    if (block) {
      this.spinnerLoading.showSpinner();
    }
    switch (method.toUpperCase()) {
      case 'GET':
        if (status === true) {
          this.headers = new HttpHeaders().set(this.modelSesion.tokenName, this.localStorageService.getItem(Constanst.STORAGE_DATA_CODE) || '')
            .set(this.modelSesion.contentType, this.modelSesion.contentTypeValue)
            .set(this.modelSesion.platformName, this.modelSesion.platformValue);
          return this.httpClient.get(environment.apiUrl + route, { headers: this.headers });
        } else {
          this.headers = new HttpHeaders().set(this.modelSesion.platformName, this.modelSesion.platformValue)
            .set(this.modelSesion.contentType, this.modelSesion.contentTypeValue);
          return this.httpClient.get(environment.apiUrl + route, { headers: this.headers });
        }
      case 'POST':
        if (data != null) {
          if (status === true) {
            this.headers = new HttpHeaders().set(this.modelSesion.platformName, this.modelSesion.platformValue).
              set(this.modelSesion.tokenName, this.localStorageService.getItem(Constanst.STORAGE_DATA_CODE) || '').
              set(this.modelSesion.contentType, 'multipart/form-data; boundary=' + (new Date()).getTime()).
              set('enctype', 'multipart/form-data').
              set('Accept', 'application/json').
              set(this.modelSesion.apiKeyName, this.modelSesion.apiKeyValue);
            this.json = JSON.stringify(data);
            return this.httpClient.post(environment.apiUrl + route, data, { headers: this.headers });
          } else {
            this.headers = new HttpHeaders().set(this.modelSesion.platformName, this.modelSesion.platformValue)
              .set(this.modelSesion.contentType, this.modelSesion.contentTypeValue)
              .set(this.modelSesion.apiKeyName, this.modelSesion.apiKeyValue);
            this.json = JSON.stringify(data);
            return this.httpClient.post(environment.apiUrl + route, this.json, { headers: this.headers });

          }
        } else {
          if (status === true) {
            this.headers = new HttpHeaders().set(this.modelSesion.tokenName, this.localStorageService.getItem(Constanst.STORAGE_DATA_CODE) || '')
              .set(this.modelSesion.contentType, this.modelSesion.contentTypeValue)
              .set(this.modelSesion.platformName, this.modelSesion.platformValue);
            this.json = {};
            return this.httpClient.post(environment.apiUrl + route, this.json, { headers: this.headers });
          } else {
            this.headers = new HttpHeaders().set(this.modelSesion.tokenName, this.modelSesion.tokenValue)
              .set(this.modelSesion.contentType, this.modelSesion.contentTypeValue)
              .set(this.modelSesion.platformName, this.modelSesion.platformValue);
            this.json = {};
            return this.httpClient.post(environment.apiUrl + route, this.json, { headers: this.headers });
          }
        }
      default: {
        return this.httpClient.post(environment.apiUrl + route, this.json, { headers: this.headers });
      }
    }
  }

  hideSpinner() {
    this.spinnerLoading.hideSpinner();
  }

  showSpinner() {
    this.spinnerLoading.showSpinner();
  }
}
